import {
    ICellMetric,
    ICellMetricAggregator,
    ICellMetricAggregatorCalcLevel,
    ICellMetricPushDownMethod, ICellMetricPushDownOptions, ICellMetricRenderOptions
} from "./PA.HyperRectangle.IF";


export class LeafColumnMetric
    implements ICellMetric
{

    private _metricId: string;
    private _metricName: string;
    private _metricFieldName: string;
    private _options: { [p: string]: any };
    private _renderOptions: ICellMetricRenderOptions;


    constructor(metricId: string,
                metricName: string,
                metricFieldName?: string,
                options?: { [p: string]: any },
                renderOptions?: ICellMetricRenderOptions)
    {
        //--
        this._metricId = metricId
        this._metricName = metricName
        this._metricFieldName = metricFieldName || metricId
        this._options = options || {}
        this._renderOptions = renderOptions || <any> {}
    }

    get MetricId(): string { return this._metricId }
    get MetricName(): string { return this._metricName }
    get MetricFieldName(): string { return this._metricFieldName }
    get Options(): { [p: string]: any } { return this._options }
    get GroupName(): string {
        return "Leaf Only"
    }
    get RenderOptions(): ICellMetricRenderOptions { return this._renderOptions }


    get AggregatorCalcLevel(): ICellMetricAggregatorCalcLevel { return undefined }
    Aggregator(): ICellMetricAggregator { return undefined; }
    get PushDownMethod(): ICellMetricPushDownMethod { return undefined }
    get PushDownOptions(): ICellMetricPushDownOptions { return {} }

    get SupportingMetricsIds(): string[] { return [] }
    get bIsHidden(): boolean { return true }
    get bIsLeafLevelOnly(): boolean { return true }
    get bIsReadOnly(): boolean { return true }




}